<div class="layout-footer">
    <div class="prava">
        <span class="plavo">©2023 eArhiv</span>
        <p> Sva prava pridržana.</p>
    </div>
    <img [src]="'assets/images/logo.png'" alt="REPUBLIKA HRVATSKA,Ministarstvo kulture i medija">
    <img [src]="'assets/images/eu.png'" alt="Financira Europska unija,NextGenerationEU">
    <!-- <div class="flex gap-2">
        <button pButton pRipple type="button" icon="pi pi-github"
            class="p-button-rounded p-button-text p-button-plain"></button>
        <button pButton pRipple type="button" icon="pi pi-facebook"
            class="p-button-rounded p-button-text p-button-plain"></button>
        <button pButton pRipple type="button" icon="pi pi-twitter"
            class="p-button-rounded p-button-text p-button-plain"></button>
    </div> -->
    <p>Izrada nacionalnog arhivskog informacijskog sustava financirana je sredstvima Mehanizma za oporavak i otpornost. 
        Sadržaj internetske stranice isključivo je odgovornost nadležne institucije. </p>
</div>